import React from "react"
import { injectIntl, defineMessages } from "react-intl"
import Toggle from "react-toggle"
import { Intl } from "../../../state/helpers/IntlProps"
import EcommerceSettingMapping from "../../../state/ecommerce-configuration/EcommerceSettingMapping"

type OwnProps = {
    intl: Intl
    settingsMapping: EcommerceSettingMapping
    onChangeCallback: (x: string) => void
}


const labelMessage = defineMessages({
    "showUnitPrice": {
        id: "ecommerce.components.ecommerce_setting_toggle.show_unit_price_label",
        defaultMessage: "Show unit price",
    },
    "showLineSubtotal": {
        id: "ecommerce.components.ecommerce_setting_toggle.show_line_subtotal_label",
        defaultMessage: "Show line subtotal",
    },
    "showCartSubtotal": {
        id: "ecommerce.components.ecommerce_setting_toggle.show_cart_subtotal_label",
        defaultMessage: "Show cart subtotal",
    },
    "enabled": {
        id: "ecommerce.components.ecommerce_setting_toggle.enabled_label",
        defaultMessage: "Enabled",
    },
    "showOnProductPage": {
        id: "ecommerce.components.ecommerce_setting_toggle.show_on_product_page_label",
        defaultMessage: "Show on product page",
    },
    "showOnCollectionPage": {
        id: "ecommerce.components.ecommerce_setting_toggle.show_on_collection_page_label",
        defaultMessage: "Show on collection page",
    },
    "showPlaceholder": {
        id: "ecommerce.components.ecommerce_setting_toggle.show_placeholder",
        defaultMessage: "Show placeholder",
    },
})

const EcommerceSettingsMappingToggles = (props: OwnProps) => {
    return (
        <div>
            {props.settingsMapping?.getAttributes() &&
                <div>
                    {Object.keys(props.settingsMapping.getAttributes()).map(key => {
                        if (!labelMessage[key]) {
                            return <></>
                        }
                        
                        return (
                            <div key={key} className="form-group row">
                                <label className="col-2 col-form-label text-align-right pt-0" htmlFor={key}>
                                    {props.intl.formatMessage(labelMessage[key])}
                                </label>

                                <div className="col-10">
                                    <div className="input-group mb-3">
                                        <Toggle
                                            id={key}
                                            checked={props.settingsMapping.getAttributes()[key]}
                                            icons={false}
                                            onChange={() => { props.onChangeCallback(key) }} />
                                    </div>
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
            }
        </div>

    )

}

export default injectIntl(EcommerceSettingsMappingToggles)


// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceSettingsTogglesComponent.tsx